import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {mapParseItem} from '@brunata-angular/util';
import {environment} from 'src/environments/environment';
import {interceptorSkipHeader} from '@shared/utils/errorInterceptor';
import {SearchResults, searchResultsSchema} from './search.model';

export const MIN_SEARCH_QUERY_LENGTH = 2;
export const MAX_SEARCH_QUERY_LENGTH = 100;

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    private readonly http = inject(HttpClient);

    search(query: string): Observable<SearchResults> {
        return this.http
            .get(`${environment.onlineServiceUrl}/search`, {
                params: {query},
                // The modal renders its own error state, so the global error toast would double it.
                headers: new HttpHeaders().set(interceptorSkipHeader, ''),
            })
            .pipe(mapParseItem(searchResultsSchema));
    }
}
